// EXAMPLE:
// const response = this.$api.user.getUsers({ search[first_name]: 'Тимур' });
// this.$rApi.user.getUsers({ params: { search[first_name]: 'Тимур' }, obs: validationObserver });

import Directories from '@/services/API/directories';
import DirectoryDocuments from '@/services/API/directory-documents';
import Events from '@/services/API/event/index';
import Teams from '@/services/API/team/index';
import User from '@/services/API/user/index';
import Polls from '@/services/API/poll/index';
import Subordinations from '@/services/API/subordination';
import Address from '@/services/API/address';
import Upload from '@/services/API/upload';
import Expertise from '@/services/API/expertise/index';
import Stages from '@/services/API/event-stage';
import Rewards from '@/services/API/event-reward';
import News from '@/services/API/news';
import Notifications from '@/services/API/notification';
import EventsPublic from '@/services/API/event/_public';
import Votes from '@/services/API/event-vote';
import Auth from '@/services/API/auth/auth';
import Telegram from '@/services/API/telegram';
import Exchanges from '@/services/API/exchange';
import Moderation from '@/services/API/moderation';
import EventGallery from '@/services/API/event-gallery';
import Dadata from '@/services/API/dadata';
import EventManagers from '@/services/API/event-managers';
import GiftedChildren from '@/services/API/gifted-children';
import Admin from '@/services/API/admin';
import OwnExchanges from '@/services/API/owner-exchange';
import Documents from '@/services/API/documents';
import Places from '@/services/API/places';
import Regions from '@/services/API/regions';
import UserDuplicates from '@/services/API/user-duplicates';
import EventAnnouncements from '@/services/API/event-announcements';
// from CRUD
import Widgets from '@/services/API/crud/widgets';
import Quotas from '@/services/API/crud/quotas';
import UserAttributes from '@/services/API/crud/user-attributes';
import EventCategories from '@/services/API/crud/event-categories';
import EventSignificances from '@/services/API/crud/event-significances';
import EventGroups from '@/services/API/crud/event-groups';
import UserDuplicatesCRUD from '@/services/API/crud/user-duplicates';
import Nominations from '@/services/API/crud/nominations';
import CriterionSets from '@/services/API/crud/criterion-sets';
import UserEventInfoRequests from '@/services/API/crud/user-event-info-requests';
import EventNominations from '@/services/API/crud/event-nominations';
import EventAssociations from '@/services/API/crud/event-associations';
import Mailing from '@/services/API/crud/mailing';

import { withRHandler } from '@/utils/withRHandler';
import eventPages from '@/services/API/event-pages';

export const services = {
  dir: Directories,
  events: Events,
  eventsPublic: EventsPublic,
  teams: Teams,
  user: User,
  polls: Polls,
  subordinations: Subordinations,
  address: Address,
  expertise: Expertise,
  stages: Stages,
  news: News,
  rewards: Rewards,
  experts: Expertise,
  notifications: Notifications,
  votes: Votes,
  exchanges: Exchanges,
  dadata: Dadata,
  eventGallery: EventGallery,
  admin: Admin,
  ownExchanges: OwnExchanges,
  documents: Documents,
  places: Places,
  regions: Regions,
  userDuplicates: UserDuplicates,
  eventAnnouncements: EventAnnouncements,
  // from CRUD
  widgets: Widgets,
  quotas: Quotas,
  userAttributes: UserAttributes,
  eventCategories: EventCategories,
  eventSignificances: EventSignificances,
  eventGroups: EventGroups,
  userDuplicatesCRUD: UserDuplicatesCRUD,
  nominations: Nominations,
  criterionSets: CriterionSets,
  userEventInfoRequests: UserEventInfoRequests,
  eventNominations: EventNominations,
  mailing: Mailing,
};

export const rServices = {
  events: withRHandler(Events),
  eventsPublic: withRHandler(EventsPublic),
  journals: withRHandler(Polls.journal),
  polls: withRHandler(Polls),
  teams: withRHandler(Teams),
  upload: withRHandler(Upload),
  stages: withRHandler(Stages),
  rewards: withRHandler(Rewards),
  user: withRHandler(User),
  directories: withRHandler(Directories),
  directoryDocuments: withRHandler(DirectoryDocuments),
  news: withRHandler(News),
  notifications: withRHandler(Notifications),
  expertise: withRHandler(Expertise),
  auth: withRHandler(Auth),
  telegram: withRHandler(Telegram),
  votes: withRHandler(Votes),
  exchanges: withRHandler(Exchanges),
  subordinations: withRHandler(Subordinations),
  moderation: withRHandler(Moderation),
  address: withRHandler(Address),
  eventGallery: withRHandler(EventGallery),
  eventManagers: withRHandler(EventManagers),
  giftedChildren: withRHandler(GiftedChildren),
  admin: withRHandler(Admin),
  ownExchanges: withRHandler(OwnExchanges),
  documents: withRHandler(Documents),
  places: withRHandler(Places),
  regions: withRHandler(Regions),
  userDuplicates: withRHandler(UserDuplicates),
  eventAnnouncements: withRHandler(EventAnnouncements),
  // from CRUD
  widgets: withRHandler(Widgets),
  quotas: withRHandler(Quotas),
  userAttributes: withRHandler(UserAttributes),
  eventCategories: withRHandler(EventCategories),
  eventSignificances: withRHandler(EventSignificances),
  eventGroups: withRHandler(EventGroups),
  userDuplicatesCRUD: withRHandler(UserDuplicatesCRUD),
  nominations: withRHandler(Nominations),
  criterionSets: withRHandler(CriterionSets),
  userEventInfoRequests: withRHandler(UserEventInfoRequests),
  eventNominations: withRHandler(EventNominations),
  eventAssociations: withRHandler(EventAssociations),
  mailing: withRHandler(Mailing),
  eventPages: withRHandler(eventPages),
};

const Api = {
  install: (Vue) => {
    Vue.api = services;

    // Deprecated format
    Vue.prototype.$api = services;
    // New format api rHandler wrapped
    Vue.prototype.$rApi = rServices;
  },
};

export default Api;
